import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Row } from 'react-bootstrap';
import { ChatContext } from 'context/Context';

const ChatContentHeader = ({ setHideSidebar }) => {
  const { currentThread } = useContext(ChatContext);

  return (
    <div className="chat-content-header shadow-sm">
      <Row className="flex-between-center">
        <Col xs={6} md={8} alignitems="center">
          <div
            className="pe-3 text-700 d-md-none contacts-list-show cursor-pointer"
            onClick={() => { setHideSidebar(true); console.log('CLICKED?') }}
          >
            <FontAwesomeIcon icon="chevron-left" />
          </div>
          <div className="min-w-0">
            <h5 className="mb-0 text-truncate fs-9"><i>{currentThread?.messages[0]?.question || 'How can I help you?'}</i></h5>
          </div>
        </Col>
        <Col xs="auto">
        </Col>
      </Row>
    </div>
  );
};

ChatContentHeader.propTypes = {
  setHideSidebar: PropTypes.func.isRequired
};

export default memo(ChatContentHeader);
